import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Textarea from 'af-fields/Textarea';

import WorkRequestUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn8, formSectionClassRow } from '../../helpers';

const WORK_SUMMARY_MAX_LENGTH = 600;

const SummaryOfWorkSection: React.FC = () => {
	return (
		<div className={formSectionClass}>
			<div className={formSectionClassRow}>
				<SegmentLabel
					label="Summary of Work"
					tooltip="Job notes shown on the Work Order, visible to the worker on the WO Confirmation modal."
				/>
			</div>
			<div className="m-b-m" />
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					<Field
						component={Textarea}
						maxCharacters={WORK_SUMMARY_MAX_LENGTH}
						name={WorkRequestUpsertFM.getAttributeName('requestJobNote')}
						placeholder="Enter text"
						rows={4}
						showMaxCharactersLabel={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(SummaryOfWorkSection);
